<template>
	<div class="message-wrap">
    <div class="message-group" v-if="showGroup">
      <div class="no-data-wrap" v-if="!list || list.length == 0">
        <img src="../../assets/live/no_data.png" />
      </div>
      <div v-for="(item, index) in list" :key="index" @click="groupClick(item)">
        <div class="group-message-item-wrap">
          <div class="group-message-item">
            <img :src="item.id === 1 ? '/static/image/live/sys_customer_default_logo_icon.png' : '/static/image/live/kmc_customer_default_logo_icon.png' " />
            <div class="detail">
              <span class="title">{{item.name}}</span>
              <span class="desc-content">
                <template v-if="item.lastMsg">
                  {{item.lastMsg.Msg}}
                </template>
              </span>
            </div>
            <span class="time">
              <template v-if="item.lastMsg">
                {{getDateTime(item.lastMsg.CreateTime)}}
              </template>
            </span>
          </div>
          <div class="line group-line"></div>
        </div>
      </div>
    </div>
    <div v-else class="message-list">
      <div class="room-nav-back">
            <img src="@/assets/live/back_icon.png" @click="backClick" />
            <span class="course-title">
              {{curGroup.name}}
            </span>
      </div>
      <div class="no-data-wrap" v-if="!list || list.length == 0">
        <img src="../../assets/live/no_data.png" />
      </div>
      <div class="message-list-item" v-for="(item, index) in detailList" :key="index">
        <div class="message-top">
            <img class="tip-img" src="/static/image/live/tab_news_selected.png"/>
            <span class="message-time">{{getDateTime(item.CreateTime)}}</span>
        </div>
        <div class="message-content">
          {{item.Msg}}
        </div>
        <div class="line message-line"></div>
      </div>
    </div>
    <div class="load-more" v-if="!showGroup || (!list || list.length == 0)" >
      <div @click="getMoreClick" class="load-more-text">加载更多</div>
    </div>
  </div>
</template>

<script>
// /api/v1/user/group?type=1 HTTP/1.1

// {
//   "code": 0,
//   "msg": "OK",
//   "data": [
//     {
//       "id": 1,
//       "name": "好未来",
//       "logo": "",
//       "type": 2
//     }
//   ]
// }
export default {
  name: 'Message',
  data () {
    return {
      showGroup: true,
      curGroup: null,
      detailList: [
      ],
      list: [
        {
           "id": 1,
                "name": "系统消息",
                "logo": "",
                "type": 2
        }
      ],
      ts: 0
    }
  },
  mounted () {
    this.getGroups()
  },
  computed: {

  },
  methods: {
    getMoreClick: function () {
      this.getUserMsglist(this.curGroup)
    },
    backClick: function () {
      this.showGroup = true
      this.ts = 0
      this.detailList = []
    },
    groupClick: function (item) {
      this.showGroup = false
      // 获取message信息
      this.curGroup = item
      this.getUserMsglist(item)
    },
    getUserMsglist: function (item) {
      let data = {
        groupid: item.id,
        ts: this.ts
      }
      this.$api.liveServer.getUserGroupMsg(data).then(res => {
        if (res.code === 0) {
          if (res.data == null || res.data.length == 0) {
            console.log('没有更多数据了')
            return
          }
          this.detailList.push(...res.data)
          let lastItem = this.detailList[this.detailList.length - 1]
          this.ts = new Date(lastItem.CreateTime).getTime()/1000
          console.log('ts ' + this.ts)
        }
      })
    },
    getGroups: function () {
      let data = {
        type: this.$store.getters.getUserType
      }
      this.$api.liveServer.getUserGroups(data).then(res => {
        if (res.code === 0) {
          this.list.push(...res.data)
          this.forEachGroupLastMsg()
        }
      })
    },
    forEachGroupLastMsg: function () {
      //  循环获取每一个group的最新消息
      if (this.list != null) {
        this.list.forEach(item => {
          this.getSignleGroupLastMsg(item)
        })
      }
    },

    // "Id": 3,
    // "Msg": "今天所有课程延迟半小时上课",
    // "CreateUser": "就叫K",
    // "CreateTime": "2019-12-19 19:35:42"
    getSignleGroupLastMsg: function (item) {
      // 单独获取某一个部门最新消息
      let data = {
        groupid: item.id,
        ts: 0
      }
      this.$api.liveServer.getUserGroupMsg(data).then(res => {
        if (res.code === 0) {
          let resList = res.data
          if (resList === null) {
            return
          }
          let len = resList.length
          if (len > 0) {
            let lastMsg = resList[0]
            item.lastMsg = lastMsg
            this.$forceUpdate()
          }
        }
      })
    },
    getDateTime: function (date) {
      let arr = date.split(' ')
      let ymd = arr[0]
      let hms = arr[1]
      let hmsArr = hms.split(':')
      let hm = hmsArr[0] + ':' + hmsArr[1]
      let ymdArr = ymd.split('-')
      let md = ymdArr[1] + '月' + ymdArr[2] + '日'
      return md + ' ' + hm
    }
  }
}
</script>

<style scoped>
  .message-wrap{
    min-height: 750px;
  }

  .group-message-item-wrap {
     margin: 20px 20px 20px 20px;
  }

  .group-message-item{
    display: flex;
    flex-direction: row;
    height: 40px;
    align-items: center;

    cursor: pointer;
  }
  .desc-content{

  }
  .group-message-item img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .group-message-item .detail{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 20px;
  }

 .group-message-item .detail .title{
    color: #666666;
    font-size: 16px;
  }

 .group-message-item .detail .desc-content{
    color: #9B9B9B;
    font-size: 14px;
    margin-top: 5px;
    width: 550px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    text-align: left;
  }
  .group-message-item .time{
    color: #E1E1E1;
    font-size: 14px;
  }

  .group-line{
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .line{
    height: 1px;
    width: 100%;
    border-bottom: 1px solid #cccccc;
  }

  .message-list{
    padding: 20px;
  }

  .message-list .message-list-item{

  }

  .tip-img{
    width: 20px;
  }

  .message-top{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .message-time{
    color: #E1E1E1 ;
    font-size: 14px;
    margin-left: 10px;
  }

  .message-content{
    margin-top: 10px;
    text-align: -moz-left;
    text-align: -webkit-left;
    color: #666666;
    overflow: hidden;
    word-wrap: break-word;
  }

  .message-line{
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .room-nav-back{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
  }
  .room-nav-back img{
    width: 20px;
    cursor: pointer;
  }

  .room-nav-back span{
    color: #4A4A4A;
    font-size: 18px;
    margin-left: 20px;
  }

  .no-data-wrap{
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .load-more{
    width: 100%;
    text-align: center;
  }

  .load-more-text{
    cursor: pointer;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/live/Message.vue